import { useNavigate } from 'react-router'

import useAppDispatch from '@/hooks/useAppDispatch'
import { CANNOT_VIEW_REFERRAL_REASON } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import { resetOutlookReferral } from '@/redux/slices/outlookReferral'
import {
  CreateReferralResponse,
  LogDirectLeadReferralResponse,
} from '@/types/responses/referrals'

export function useHandleSuccessfulOutlookReferral() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return function handleReferralSuccess(
    referral: CreateReferralResponse | LogDirectLeadReferralResponse,
  ) {
    dispatch(resetOutlookReferral())

    if (
      referral.cannotViewReferralReason ===
      CANNOT_VIEW_REFERRAL_REASON.NON_ADMIN
    ) {
      navigate(ROUTES.officeInaccessibleReferralConfirmation())
      return
    }

    navigate(
      ROUTES.officeReferralConfirmation({
        params: { referralId: referral.id.toString() },
      }),
    )
  }
}
